webpackJsonp([200415589436167],{

/***/ 206:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 155:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Blog = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(206);
	
	var _Heading = __webpack_require__(7);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _contentPage = __webpack_require__(4);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(5);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	__webpack_require__(10);
	
	var _reactAnimateOnScroll = __webpack_require__(11);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	var _reactFacebookPixel = __webpack_require__(9);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _reactTabs = __webpack_require__(150);
	
	__webpack_require__(93);
	
	var _gatsbyLink = __webpack_require__(6);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _blogConstant = __webpack_require__(65);
	
	var _reactSpinners = __webpack_require__(21);
	
	var _reactResponsive = __webpack_require__(23);
	
	var _reactResponsive2 = _interopRequireDefault(_reactResponsive);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var krTabs = ["article", "case studies", "extract", "program", "podcast", "report", "research", "survey", "contributor spotlight"];
	
	var Blog = exports.Blog = function (_React$Component) {
	  _inherits(Blog, _React$Component);
	
	  function Blog(args) {
	    _classCallCheck(this, Blog);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.updateURL = function () {
	      if (typeof window !== "undefined") {
	        if (_this.state.activeKeyword.split(" ").join("_").length) {
	          var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?q=" + _this.state.activeKeyword.split(" ").join("_");
	          window.history.replaceState({ path: window.location.pathname }, "", newurl);
	        } else {
	          var _newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
	          window.history.replaceState({ path: window.location.pathname }, "", _newurl);
	        }
	      }
	    };
	
	    _this.selectKRTab = function (tabName) {
	      if (tabName !== _this.state.selectedTab) {
	        _this.setState({ selectedTab: tabName });
	      } else {
	        _this.setState({ selectedTab: null });
	      }
	    };
	
	    _this.handleSearch = function (e, q) {
	      // console.log("q", q)
	      // console.log("e", e)
	      var str = q || (e && e.target.value.length ? e.target.value.toLowerCase() : "");
	      _this.setState({
	        isSearching: true,
	        activeKeyword: str
	      });
	      var videoslist = [].concat(_blogConstant.knowledgeResources);
	      _this.knowledgeResourcesContent = [];
	      videoslist.forEach(function (item) {
	        if (item.sdata.toLowerCase().trim().search(str) > -1) {
	          _this.knowledgeResourcesContent.push(item);
	        }
	      });
	      setTimeout(function () {
	        _this.setState({
	          isSearching: false
	        });
	      }, 1000);
	    };
	
	    _this.state = {
	      Error: {},
	      values: {},
	      activeKeyword: "",
	      isSearching: false,
	      Canonical: "",
	      browserHistory: [],
	      selectedTab: null
	    };
	    _this.knowledgeResourcesContent = _blogConstant.knowledgeResources;
	    return _this;
	  }
	
	  Blog.prototype.componentDidMount = function componentDidMount() {
	    _reactFacebookPixel2.default.init("2879175222167037");
	    _reactFacebookPixel2.default.track("ViewContent", location);
	  };
	
	  Blog.prototype.componentWillMount = function componentWillMount() {
	    if (typeof window !== "undefined") {
	      var q = window.location.search.split("=")[1];
	      if (q) {
	        this.setState({ activeKeyword: q });
	        q = q.split("_").join(" ");
	        q && this.handleSearch(null, q);
	      }
	    }
	  };
	
	  Blog.prototype.render = function render() {
	    var _this2 = this;
	
	    var _state = this.state,
	        isSearching = _state.isSearching,
	        selectedTab = _state.selectedTab;
	    var _props = this.props,
	        location = _props.location,
	        history = _props.history;
	
	
	    var dataToRender = void 0;
	    if (selectedTab !== null) {
	      dataToRender = this.knowledgeResourcesContent.filter(function (item) {
	        return item.type === selectedTab;
	      });
	    } else {
	      dataToRender = this.knowledgeResourcesContent;
	    }
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe | Diversity is Now | Resources",
	        image: "http://winpeforum.com/assets/elements/Winpe_Knowledge_centre_banner_400X400.jpg",
	        description: "Explore and subscribe to industry insights, knowledge resources and updates by the key stakeholders addressing diversity issues in private equity.",
	        location: location
	      }),
	      _react2.default.createElement(_meta2.default, {
	        title: "Winpe | Diversity is Now | Resources",
	        image: "http://winpeforum.com/assets/elements/WinPE_Knowledge_Centre_link_image.jpg",
	        description: "Explore and subscribe to industry insights, knowledge resources and updates by the key stakeholders addressing diversity issues in private equity.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "section__content" },
	        _react2.default.createElement(
	          "div",
	          { className: "blog__wrapper" },
	          _react2.default.createElement(
	            "div",
	            { className: "back_home" },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: "/home" },
	              _react2.default.createElement(
	                "i",
	                { className: "fa fa-arrow-left" },
	                " Back to Home"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "blog__section" },
	            _react2.default.createElement(
	              "div",
	              { className: "blog_content" },
	              _react2.default.createElement("div", { className: "low__heading" }),
	              _react2.default.createElement(
	                "div",
	                { className: "" },
	                _react2.default.createElement(_Heading2.default, { title: "KNOWLEDGE RESOURCES" })
	              ),
	              _react2.default.createElement("div", { className: "sub__body__text" }),
	              _react2.default.createElement(
	                _reactAnimateOnScroll2.default,
	                {
	                  delay: 0,
	                  duration: 2,
	                  animateIn: "slideInRight",
	                  offset: 600
	                },
	                _react2.default.createElement(
	                  "div",
	                  { className: "blog_mid_section" },
	                  _react2.default.createElement(
	                    "div",
	                    { className: "blog_mid_text" },
	                    _react2.default.createElement(
	                      "div",
	                      { className: "row" },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "col-md-12" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "blog_mid_text" },
	                          _react2.default.createElement(
	                            _reactTabs.Tabs,
	                            null,
	                            _react2.default.createElement(
	                              _reactTabs.TabList,
	                              null,
	                              _blogConstant.TabContent.map(function (item, l) {
	                                return _react2.default.createElement(
	                                  _reactTabs.Tab,
	                                  { key: l },
	                                  item.tabName
	                                );
	                              })
	                            ),
	                            _react2.default.createElement("div", { className: "border_end" }),
	                            _react2.default.createElement(
	                              _reactTabs.TabPanel,
	                              null,
	                              _react2.default.createElement(
	                                "div",
	                                { className: "row" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "blog_listing_section" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "knowledgeresources" },
	                                    _react2.default.createElement(
	                                      _reactResponsive2.default,
	                                      { query: "(min-width: 768px)" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "knowledgeresources__tabs" },
	                                          krTabs.map(function (item, i) {
	                                            return _react2.default.createElement(
	                                              "div",
	                                              {
	                                                className: "knowledgeresources__tabs__tab " + (_this2.state.selectedTab === item && " knowledgeresources__tabs__tab--selected"),
	                                                onClick: function onClick() {
	                                                  return _this2.selectKRTab(item);
	                                                }
	                                              },
	                                              item + (item !== "research" && item !== "case studies" ? "s" : ""),
	                                              _this2.state.selectedTab === item ? _react2.default.createElement(
	                                                "span",
	                                                {
	                                                  style: {
	                                                    // display: "inline-block",
	                                                    marginLeft: "10px"
	                                                  }
	                                                },
	                                                " ",
	                                                "\u2715"
	                                              ) : null
	                                            );
	                                          })
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "listing_heading" },
	                                          "knowledge resources"
	                                        )
	                                      )
	                                    ),
	                                    _react2.default.createElement(
	                                      _reactResponsive2.default,
	                                      { query: "(max-width: 767px)" },
	                                      _react2.default.createElement(
	                                        "div",
	                                        null,
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "knowledgeresources__tabs" },
	                                          krTabs.map(function (item, i) {
	                                            return _react2.default.createElement(
	                                              "div",
	                                              {
	                                                className: "knowledgeresources__tabs__tab " + (_this2.state.selectedTab === item && " knowledgeresources__tabs__tab--selected"),
	                                                onClick: function onClick() {
	                                                  return _this2.selectKRTab(item);
	                                                }
	                                              },
	                                              item + (item !== "research" && item !== "case studies" ? "s" : ""),
	                                              _this2.state.selectedTab === item ? _react2.default.createElement(
	                                                "span",
	                                                {
	                                                  style: {
	                                                    // display: "inline-block",
	                                                    marginLeft: "10px"
	                                                  }
	                                                },
	                                                " ",
	                                                "\u2715"
	                                              ) : null
	                                            );
	                                          })
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "listing_heading" },
	                                          "knowledge resources"
	                                        ),
	                                        _react2.default.createElement(
	                                          "div",
	                                          { className: "left_scr_box" },
	                                          _react2.default.createElement("input", {
	                                            type: "search",
	                                            placeholder: "Search",
	                                            onChange: function onChange(e) {
	                                              return _this2.handleSearch(e);
	                                            },
	                                            value: this.state.activeKeyword
	                                          })
	                                        )
	                                      )
	                                    )
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "row" },
	                                    isSearching ? _react2.default.createElement(
	                                      "div",
	                                      { style: { margin: "10% 50% 10%" } },
	                                      _react2.default.createElement(_reactSpinners.ClipLoader, {
	                                        color: "#22316B",
	                                        loading: isSearching
	                                      })
	                                    ) : dataToRender.length ? dataToRender.map(function (item, k) {
	                                      return _react2.default.createElement(
	                                        "div",
	                                        {
	                                          className: "col-md-12 col-xs-12 col-sm-12",
	                                          key: k
	                                        },
	                                        _react2.default.createElement(
	                                          "a",
	                                          {
	                                            href: item.listlink,
	                                            target: "_blank"
	                                          },
	                                          _react2.default.createElement(
	                                            "div",
	                                            { className: "listing_map" },
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "listing_map_date" },
	                                              item.date
	                                            ),
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "list_right" },
	                                              _react2.default.createElement("div", {
	                                                className: "listing_map_heading",
	                                                dangerouslySetInnerHTML: {
	                                                  __html: item.title
	                                                }
	                                              }),
	                                              _react2.default.createElement(
	                                                "div",
	                                                { className: "listing_map_subheading" },
	                                                item.auto
	                                              )
	                                            )
	                                          )
	                                        )
	                                      );
	                                    }) : _react2.default.createElement(
	                                      "div",
	                                      { className: "no__product" },
	                                      "Not available in the list"
	                                    )
	                                  )
	                                )
	                              )
	                            ),
	                            _react2.default.createElement(
	                              _reactTabs.TabPanel,
	                              null,
	                              _react2.default.createElement(
	                                "div",
	                                { className: "row" },
	                                _react2.default.createElement(
	                                  "div",
	                                  { className: "blog_listing_section" },
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "listing_heading1" },
	                                    "NewsLetters"
	                                  ),
	                                  _react2.default.createElement(
	                                    "div",
	                                    { className: "row" },
	                                    _blogConstant.newsletter.map(function (item, k) {
	                                      return _react2.default.createElement(
	                                        "div",
	                                        {
	                                          className: "col-md-12 col-xs-12 col-sm-12",
	                                          key: k
	                                        },
	                                        _react2.default.createElement(
	                                          _gatsbyLink2.default,
	                                          { to: item.listlink },
	                                          _react2.default.createElement(
	                                            "div",
	                                            { className: "listing_map" },
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "listing_map_date1" },
	                                              item.datee
	                                            ),
	                                            _react2.default.createElement(
	                                              "div",
	                                              { className: "list_right1" },
	                                              _react2.default.createElement("div", {
	                                                className: "listing_map_heading",
	                                                dangerouslySetInnerHTML: {
	                                                  __html: item.title
	                                                }
	                                              }),
	                                              _react2.default.createElement(
	                                                "div",
	                                                { className: "listing_map_subheading" },
	                                                item.auto
	                                              )
	                                            )
	                                          )
	                                        )
	                                      );
	                                    })
	                                  )
	                                )
	                              )
	                            )
	                          )
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Blog;
	}(_react2.default.Component);
	
	Blog.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = Blog;

/***/ }),

/***/ 575:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _BlogComponent = __webpack_require__(155);
	
	var _BlogComponent2 = _interopRequireDefault(_BlogComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _BlogComponent2.default;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-knowledgeresources-index-js-51db52be38320459e946.js